var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16665 14.6668L5.89999 12.5335C5.75554 12.4779 5.61943 12.4113 5.49165 12.3335C5.36388 12.2557 5.23888 12.1724 5.11665 12.0835L3.13332 12.9168L1.29999 9.75016L3.01665 8.45016C3.00554 8.37238 2.99999 8.29738 2.99999 8.22516V7.77516C2.99999 7.70294 3.00554 7.62794 3.01665 7.55016L1.29999 6.25016L3.13332 3.0835L5.11665 3.91683C5.23888 3.82794 5.36665 3.74461 5.49999 3.66683C5.63332 3.58905 5.76665 3.52238 5.89999 3.46683L6.16665 1.3335H9.83332L10.1 3.46683C10.2444 3.52238 10.3805 3.58905 10.5083 3.66683C10.6361 3.74461 10.7611 3.82794 10.8833 3.91683L12.8667 3.0835L14.7 6.25016L12.9833 7.55016C12.9944 7.62794 13 7.70294 13 7.77516V8.22516C13 8.29738 12.9889 8.37238 12.9667 8.45016L14.6833 9.75016L12.85 12.9168L10.8833 12.0835C10.7611 12.1724 10.6333 12.2557 10.5 12.3335C10.3667 12.4113 10.2333 12.4779 10.1 12.5335L9.83332 14.6668H6.16665ZM8.03332 10.3335C8.67777 10.3335 9.22777 10.1057 9.68332 9.65016C10.1389 9.19461 10.3667 8.64461 10.3667 8.00016C10.3667 7.35572 10.1389 6.80572 9.68332 6.35016C9.22777 5.89461 8.67777 5.66683 8.03332 5.66683C7.37777 5.66683 6.82499 5.89461 6.37499 6.35016C5.92499 6.80572 5.69999 7.35572 5.69999 8.00016C5.69999 8.64461 5.92499 9.19461 6.37499 9.65016C6.82499 10.1057 7.37777 10.3335 8.03332 10.3335Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.bc6dc7a5cfdd901b0b6bc1ad3070260a.svg";
export { ForwardRef as ReactComponent };